import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'

// One table for every list screen. The pages all passed the same four props to
// BootstrapTable and none of them showed anything while a page was loading or
// after a request failed — so the shared piece owns the spinner, the empty state
// and the error line, and there is one place left to change them.
//
// The rows stay mounted under the overlay on purpose: replacing them with a
// spinner makes the table collapse to nothing and the page jump on every paging
// click.
export default function CoreCustomTable({
  data,
  columns,
  keyField = 'id',
  loading = false,
  error = '',
  emptyText = 'ไม่พบข้อมูล',
  ...rest
}) {
  const rows = Array.isArray(data) ? data : []

  return (
    <>
      {error ? (
        <div className="alert alert-custom alert-light-danger mb-4" role="alert">
          <div className="alert-text font-weight-bold">{error}</div>
        </div>
      ) : null}
      <div style={{ position: 'relative', minHeight: 120 }}>
        {/* `rest` is spread first on purpose: callers pass ToolkitProvider's
            baseProps, which carry their own data/columns, and the explicit props
            below have to win — the same order the call sites already relied on.

            noDataIndication is where an empty result belongs. It is never an
            alert: a search that matched nothing is a normal outcome, and a modal
            saying "Error" for it teaches operators to distrust the ones that do
            matter. Metronic's text-dark-50 is ~3.9:1 on white and fails as body
            copy, hence text-dark-65. */}
        <BootstrapTable
          {...rest}
          keyField={keyField}
          data={rows}
          columns={columns}
          wrapperClasses="table-responsive"
          bordered={false}
          classes="table table-head-custom table-vertical-center overflow-hidden"
          bootstrap4
          noDataIndication={() => (
            <div className="text-center text-dark-65 py-10">
              {loading || error ? '' : emptyText}
            </div>
          )}
        />
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)',
              zIndex: 2,
            }}
            role="status"
            aria-live="polite"
          >
            <div className="spinner-border text-primary" />
            <span className="sr-only">กำลังโหลดข้อมูล</span>
          </div>
        ) : null}
      </div>
    </>
  )
}
